import { Spinner } from 'seagull';
import styles from "./MapStatusView.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
export function MapStatusView(props) {
  const {
    mapStatus
  } = props;
  let element;
  switch (mapStatus) {
    case 'mapped':
      element = /*#__PURE__*/_jsx("div", {
        className: styles.mapped,
        children: "Mapped"
      });
      break;
    case 'notMapped':
      element = /*#__PURE__*/_jsx("div", {
        className: styles.notMapped,
        children: "Not mapped"
      });
      break;
    case 'failedToMap':
      element = /*#__PURE__*/_jsx("div", {
        className: styles.failedToMap,
        children: "Failed to map"
      });
      break;
    case 'mapping':
      element = /*#__PURE__*/_jsx(Spinner, {
        testId: "map-spinner",
        size: 32
      });
      break;
    default:
      element = null;
  }
  return /*#__PURE__*/_jsx("div", {
    "data-testid": "map-status",
    children: element
  });
}